<script language="ts">
    import VideoPlayer from 'svelte-video-player';
    import Circle from "../components/ui/circle.svelte";
    import Layout from "../components/ui/layout.svelte";
    import Button from "../components/basic/button.svelte";
    import * as animateScroll from "svelte-scrollto";
    import { onMount } from "svelte";
    import { apiServer, sitekey } from "../constant";
    import { bam_host, home_data, section_pointer } from "../store";
    import { Recaptcha } from "svelte-recaptcha-v2";
    import { toast } from '@zerodevx/svelte-toast';
    import { navigate } from 'svelte-routing';
    import { doAddressSearch } from '../components/utils/Fetching.svelte';


    let search_value = "";
    let address_not_found = false;
    async function doSearch() {
        if(search_value === null || search_value.match(/^ *$/) !== null){
            toast.push("Please enter an address to search.", {
                duration: 5000,
                dismissable: false,
                theme: {
                    '--toastBackground': '#F56565',
                    '--toastProgressBackground': '#C53030'
                }
            });
        } else {
            address_not_found = false;
            const res = {st: true, data: {}};
            if (res.st === true) {
                navigate("/booking?address_data=" + btoa(JSON.stringify(res.data)));
            } else {
                address_not_found = true;
            }
        }
    }

    let recaptchaPass = false;
    let scrollSectionKey;
    section_pointer.subscribe((value) => {
        scrollSectionKey = value;
        if (scrollSectionKey === 'section1')
            window.scrollTo(0, 0);
        else
            animateScroll.scrollTo({ element: `#${scrollSectionKey}`});
    });

    let sections = {};
    let error = null;
    onMount(async () => {
        fetch(apiServer + '/api/whyhouseofyards?populate=whyhouseofyards.video_preview&populate=whyhouseofyards.video&populate=whyhouseofyards.background1&populate=whyhouseofyards.background2', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        .then(response => response.json())
        .then(data => {
            data.data.attributes.whyhouseofyards.forEach(section => {
                sections = {
                    ...sections,
                    ...{[section.identifier]: section}
                };
            });
            home_data.set(sections);
            setTimeout(() => {
                if (scrollSectionKey === 'section1')
                    window.scrollTo(0, 0);
                else
                    animateScroll.scrollTo({ element: `#${scrollSectionKey}`});
            }, 100);
        })
        .catch(e => error = e)
    });

    onMount(() => window.scrollTo(0,0));
    let circleWidth, xVar, yVar;

    $: dispatchResize()

    const dispatchResize = () => {
        circleWidth = window.innerWidth > 1300 ? 270 : (window.innerWidth > 500 ? 220 : 140);
        xVar = window.innerWidth > 1300 ? 170 : (window.innerWidth > 500 ? 140 : 80) ;
        yVar = window.innerWidth > 1300 ? 150 : (window.innerWidth > 500 ? 120 : 80);
    }

    const alpha = Math.PI * 2/7;
    
    const on_click_func = () => {
        // window.location.href = '/pricing';
        window.location.href = $bam_host + '/Register_Plan?plan_type=free&domain_name=sample';
    }
</script>
<svelte:window on:resize={dispatchResize}></svelte:window>

<div class="page-container" id="mainDiv">
    <Layout>
        {#if (Object.keys(sections).length)}
            {#if sections['section1'].show_or_hide === 'show'}
            <div
                class="main" 
                style={`background-image: url(${apiServer + ((sections['section1'] && sections['section1'].background1.data) ? sections['section1'].background1.data.attributes.url : '')});`}
                id="section1"
            >
                <div class="background" />
                <div class="hero-container" id="hero">
                    <div class="hero">
                        <div>
                            <h1 class="hero-title">
                                {sections['section1'] ? sections['section1'].title : ''}
                            </h1>
                            <div class="hero-description">
                                {sections['section1'] ? sections['section1'].content : ''}
                            </div>
                            <div class="more-button">
                                <Button on_click_func={on_click_func} title={sections['section1'] ? sections['section1'].button_text : ''} />
                            </div>
                        </div>
                        <div class="right">
                            <div class="video-container">
                                <img
                                    src={apiServer + ((sections['section1'] && sections['section1'].background2.data) ? sections['section1'].background2.data.attributes.url : '')}
                                    alt={(sections['section1'] && sections['section1'].background2.data) ? sections['section1'].background2.data.attributes.alternativeText : ''}
                                    class="mac-book"
                                />
                                <div class="video">
                                    <VideoPlayer
                                        source={apiServer + ((sections['section1'] && sections['section1'].video.data) ? sections['section1'].video.data.attributes.url : '')}
                                        poster={apiServer + ((sections['section1'] && sections['section1'].video_preview.data) ? sections['section1'].video_preview.data.attributes.url : '')}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/if}
            
            {#if sections['section2'].show_or_hide === 'show'}
            <div class="circle-container" id="section2">
                <div class="circle">
                    <img
                        src={apiServer + ((sections['section2'] && sections['section2'].background2.data) ? sections['section2'].background2.data.attributes.url : '')}
                        alt={(sections['section2'] && sections['section2'].background2.data) ? sections['section2'].background2.data.attributes.alternativeText : ''}
                    />
                    {#if sections['section2']}
                        {#each sections['section2'].extra as circleItem, i}
                            <Circle 
                                content={circleItem.label} 
                                coordinates={{x: circleWidth * Math.cos(alpha * i - 1.6) + xVar, y: circleWidth * Math.sin(alpha * i - 1.6) + yVar}}
                                handleClick={() => animateScroll.scrollTo({ element: `#${circleItem.targetId}`})}
                            />
                        {/each}
                    {/if}
                </div>
                <div class="text-container turbo-text">
                    <h1 class="circle-text">
                        {sections['section2'] ? sections['section2'].title : ''}
                    </h1>
                    <div class="more-button">
                        <Button on_click_func={on_click_func} title={sections['section2'] ? sections['section2'].button_text : ''} />
                    </div>
                </div>
            </div>
            {/if}

            {#if sections['section3'].show_or_hide === 'show'}
            <div class="client-container" id="section3">
                <div class="section-container">
                    <div class="text-container">
                        <h1 class="circle-text">
                            {sections['section3'] ? sections['section3'].title : ''}
                        </h1>
                        <p class="client-description">
                            {sections['section3'] ? sections['section3'].content: ''}
                        </p>
                        <div class="more-button">
                            <Button on_click_func={on_click_func} title={sections['section3'] ? sections['section3'].button_text : ''} />
                        </div>
                    </div>
                    <div class='right-images'>
                        <img
                            src={apiServer + ((sections['section3'] && sections['section3'].background2.data) ? sections['section3'].background2.data.attributes.url : '')}
                            class="port-img"
                            alt={(sections['section3'] && sections['section3'].background2.data) ? sections['section3'].background2.data.attributes.alternativeText : ''}
                        />
                        <div class="client-video">
                            <VideoPlayer
                                source={apiServer + ((sections['section3'] && sections['section3'].video.data) ? sections['section3'].video.data.attributes.url : '')}
                                poster={apiServer + ((sections['section3'] && sections['section3'].video_preview.data) ? sections['section3'].video_preview.data.attributes.url : '')}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {/if}

            {#if sections['section4'].show_or_hide === 'show'}
            <div
                class="instant-section"
                style={`background-image: url(${apiServer + ((sections['section4'] && sections['section4'].background1.data) ? sections['section4'].background1.data.attributes.url : '')});`}
                id="section4"
            >
                <div class="instant google-recaptcha">
                    <div class="instant-text">{sections['section4'] ? sections['section4'].title : ''}</div>
                    <p class="instant-desc">{sections['section4'] ? sections['section4'].content : ''}</p>
                    <div class="input">
                        <input
                            placeholder={((sections['section4'] && sections['section4'].extra) ? sections['section4'].extra.placeholder : '')}
                            bind:value={search_value}
                            on:keydown={(event) => {
                                if (event.key === 'Enter') {
                                    if (recaptchaPass) {
                                        doSearch();
                                    } else {
                                        toast.push(
                                            "Please verify that you are not a robot.",
                                            {
                                                duration: 5000,
                                                dismissable: false,
                                                theme: {
                                                    '--toastBackground': '#F56565',
                                                    '--toastProgressBackground': '#C53030'
                                                }
                                            }
                                        );
                                    }
                                }
                            }}
                        />
                        <div class="submit-button"
                            on:click={() =>
                                recaptchaPass ? 
                                doSearch() :
                                toast.push(
                                    "Please verify that you are not a robot", 
                                    {
                                        duration: 5000,
                                        dismissable: false,
                                        theme: {
                                            '--toastBackground': '#F56565',
                                            '--toastProgressBackground': '#C53030'
                                        }
                                    }
                                )
                            }
                        >
                            <Button
                                title={sections['section4'] ? sections['section4'].button_text : ''}
                            />
                        </div>
                    </div>
                    <button class="drive-button mob-submit"
                        on:click={() =>
                            recaptchaPass ? 
                            doSearch() :
                            toast.push(
                                "Please verify that you are not a robot", 
                                {
                                    duration: 5000,
                                    dismissable: false,
                                    theme: {
                                        '--toastBackground': '#F56565',
                                        '--toastProgressBackground': '#C53030'
                                    }
                                }
                            )
                        }
                    >
                        {sections['section4'] ? sections['section4'].button_text : ''}
                    </button>
                    {#if !recaptchaPass}
                    <div style="width: 304px; margin: auto; margin-top: 10px;">
                        <Recaptcha
                            id='googleRecaptcha'
                            style="margin: auto;"
                            sitekey={sitekey}
                            badge={"top"}
                            size={"visible"}
                            on:success={() => { setTimeout(() => {recaptchaPass = true}, 1000) }}
                            on:error={() => {console.log('error')}}
                            on:expired={() => {console.log('expired')}}
                            on:close={() => {console.log('close')}}
                            on:ready={() => {console.log('ready')}}
                        />
                    </div>
                    {/if}
                </div>
            </div>
            {/if}

            {#if sections['section5'].show_or_hide === 'show'}
            <div class="client-container" id="section5">
                <div class="section-container">
                    <div class='client-video'>
                        <VideoPlayer
                            source={apiServer + ((sections['section5'] && sections['section5'].video.data) ? sections['section5'].video.data.attributes.url : '')}
                            poster={apiServer + ((sections['section5'] && sections['section5'].video_preview.data) ? sections['section5'].video_preview.data.attributes.url : '')}
                        />
                    </div>
                    <div class="text-container">
                        <h1 class="circle-text stay-text">
                            {sections['section5'] ? sections['section5'].title : ''}
                        </h1>
                        <p class="client-description">
                            {sections['section5'] ? sections['section5'].content : ''}
                        </p>
                        <div class="more-button">
                            <Button on_click_func={on_click_func} title={sections['section5'] ? sections['section5'].button_text : ''} />
                        </div>
                    </div>
                </div>
            </div>
            {/if}

            {#if sections['section6'].show_or_hide === 'show'}
            <div class="client-container" id="section6">
                <div class="section-container">
                    <div class="text-container organize-text">
                        <h1 class="circle-text">
                            {sections['section6'] ? sections['section6'].title : ''}
                        </h1>
                        <p class="client-description">
                            {sections['section6'] ? sections['section6'].content : ''}
                        </p>
                        <div class="more-button">
                            <Button on_click_func={on_click_func} title={sections['section6'] ? sections['section6'].button_text : ''} />
                        </div>
                    </div>
                    <div class='client-video'>
                        <VideoPlayer
                            source={apiServer + ((sections['section6'] && sections['section6'].video.data) ? sections['section6'].video.data.attributes.url : '')}
                            poster={apiServer + ((sections['section6'] && sections['section6'].video_preview.data) ? sections['section6'].video_preview.data.attributes.url : '')}
                        />
                    </div>
                </div>
            </div>
            {/if}

            {#if sections['section7'].show_or_hide === 'show'}
            <div class="client-container" id="section7">
                <div class="section-container">
                    <div class='client-video'>
                        <VideoPlayer
                            source={apiServer + ((sections['section7'] && sections['section7'].video.data) ? sections['section7'].video.data.attributes.url : '')}
                            poster={apiServer + ((sections['section7'] && sections['section7'].video_preview.data) ? sections['section7'].video_preview.data.attributes.url : '')}
                        />
                    </div>
                    <div class="text-container organize-text">
                        <h1 class="circle-text">
                            {sections['section7'] ? sections['section7'].title : ''}
                        </h1>
                        <p class="client-description">
                            {sections['section7'] ? sections['section7'].content : ''}
                        </p>
                        <div class="more-button">
                            <Button on_click_func={on_click_func} title={sections['section7'] ? sections['section7'].button_text : ''} />
                        </div>
                    </div>
                </div>
            </div>
            {/if}

            {#if sections['section8'].show_or_hide === 'show'}
            <div class="client-container" id="section8">
                <div class="section-container">
                    <div class="text-container organize-text">
                        <h1 class="circle-text">
                            {sections['section8'] ? sections['section8'].title : ''}
                        </h1>
                        <p class="client-description">
                            {sections['section8'] ? sections['section8'].content : ''}
                        </p>
                        <div class="more-button">
                            <Button on_click_func={on_click_func} title={sections['section8'] ? sections['section8'].button_text : ''} />
                        </div>
                    </div>
                    <div class='client-video'>
                        <VideoPlayer
                            source={apiServer + ((sections['section8'] && sections['section8'].video.data) ? sections['section8'].video.data.attributes.url : '')}
                            poster={apiServer + ((sections['section8'] && sections['section8'].video_preview.data) ? sections['section8'].video_preview.data.attributes.url : '')}
                        />
                    </div>
                </div>
            </div>
            {/if}

            {#if sections['section9'].show_or_hide === 'show'}
            <div class="client-container" id="section9">
                <div class="section-container">
                    <div class='right-images'>
                        <img
                            src={apiServer + ((sections['section9'] && sections['section9'].background1.data) ? sections['section9'].background1.data.attributes.url : '')}
                            alt={(sections['section9'] && sections['section9'].background1.data) ? sections['section9'].background1.data.attributes.alternativeText : ''}
                            class="address"
                        />
                        <img
                            src={apiServer + ((sections['section9'] && sections['section9'].background2.data) ? sections['section9'].background2.data.attributes.url : '')}
                            alt={(sections['section9'] && sections['section9'].background2.data) ? sections['section9'].background2.data.attributes.alternativeText : ''}
                            class="form"
                        />
                        <img
                            src={apiServer + ((sections['section9'] && sections['section9'].video_preview.data) ? sections['section9'].video_preview.data.attributes.url : '')}
                            alt={(sections['section9'] && sections['section9'].video_preview.data) ? sections['section9'].video_preview.data.attributes.alternativeText : ''}
                            class="cal"
                        />
                    </div>
                    <div class="text-container take-text">
                        <h1 class="circle-text">
                            {sections['section9'] ? sections['section9'].title : ''}
                        </h1>
                        <p class="client-description">
                            {sections['section9'] ? sections['section9'].content : ''}
                        </p>
                        <div class="more-button">
                            <Button on_click_func={on_click_func} title={sections['section9'] ? sections['section9'].button_text : ''} />
                        </div>
                    </div>
                </div>
            </div>
            {/if}

            {#if sections['section10'].show_or_hide === 'show'}
            <div class="client-container" id="section10">
                <div class="section-container reduce-container">
                    <div class="text-container reduce-text">
                        <h1 class="circle-text">
                            {sections['section10'] ? sections['section10'].title : ''}
                        </h1>
                        <p class="client-description">
                            {sections['section10'] ? sections['section10'].content : ''}
                        </p>
                        <div class="more-button">
                            <Button on_click_func={on_click_func} title={sections['section10'] ? sections['section10'].button_text : ''} />
                        </div>
                    </div>
                    <div class='right-images'>
                        <img
                            src={apiServer + ((sections['section10'] && sections['section10'].background1.data) ? sections['section10'].background1.data.attributes.url : '')}
                            alt={(sections['section10'] && sections['section10'].background1.data) ? sections['section10'].background1.data.attributes.alternativeText : ''}
                            class="address"
                        />
                        <img 
                            src={apiServer + ((sections['section10'] && sections['section10'].background2.data) ? sections['section10'].background2.data.attributes.url : '')}
                            alt={(sections['section10'] && sections['section10'].background2.data) ? sections['section10'].background2.data.attributes.alternativeText : ''}
                            class="form"
                        />
                    </div>
                </div>
            </div>
            {/if}

            {#if sections['section11'].show_or_hide === 'show'}
            <div class="client-container" id="section11">
                <div class="section-container">
                    <div class='right-images'>
                        <img
                            src={apiServer + ((sections['section11'] && sections['section11'].background1.data) ? sections['section11'].background1.data.attributes.url : '')}
                            alt={(sections['section11'] && sections['section11'].background1.data) ? sections['section11'].background1.data.attributes.alternativeText : ''}
                            class="address"
                        />
                        <img
                            src={apiServer + ((sections['section11'] && sections['section11'].background2.data) ? sections['section11'].background2.data.attributes.url : '')}
                            alt={(sections['section11'] && sections['section11'].background2.data) ? sections['section11'].background2.data.attributes.alternativeText : ''}
                            class="form"
                        />
                    </div>
                    <div class="text-container reduce-text">
                        <h1 class="circle-text">
                            {sections['section11'] ? sections['section11'].title : ''}
                        </h1>
                        <p class="client-description">
                            {sections['section11'] ? sections['section11'].content : ''}
                        </p>
                        <div class="more-button">
                            <Button on_click_func={on_click_func} title={sections['section11'] ? sections['section11'].button_text : ''} />
                        </div>
                    </div>
                </div>
            </div>
            {/if}

            {#if sections['section12'].show_or_hide === 'show'}
            <div class="client-container increase-container" id="section12">
                <div class="section-container reduce-container">
                    <div class="text-container reduce-text">
                        <h1 class="circle-text">
                            {sections['section12'] ? sections['section12'].title : ''}
                        </h1>
                        <p class="client-description">
                            {sections['section12'] ? sections['section12'].content : ''}
                        </p>
                        <div class="more-button">
                            <Button on_click_func={on_click_func} title={sections['section12'] ? sections['section12'].button_text : ''} />
                        </div>
                    </div>
                    <div class='right-images'>
                        <img
                            src={apiServer + ((sections['section12'] && sections['section12'].background1.data) ? sections['section12'].background1.data.attributes.url : '')}
                            alt={(sections['section12'] && sections['section12'].background1.data) ? sections['section12'].background1.data.attributes.alternativeText : ''}
                            class="address"
                        />
                        <img
                            src={apiServer + ((sections['section12'] && sections['section12'].background2.data) ? sections['section12'].background2.data.attributes.url : '')}    
                            alt={(sections['section12'] && sections['section12'].background2.data) ? sections['section12'].background2.data.attributes.alternativeText : ''}
                            class="form"
                        />
                    </div>
                </div>
            </div>
            {/if}

            {#if sections['section13'].show_or_hide === 'show'}
            <div class="love-section" id="section13">
                <div class="loves">
                    <h1 class="circle-text">
                        {sections['section13'] ? sections['section13'].title : ''}
                    </h1>
                    <div class="love-items">
                        <img
                            src={apiServer + ((sections['section13'] && sections['section13'].video_preview.data) ? sections['section13'].video_preview.data.attributes.url : '')}    
                            alt={(sections['section13'] && sections['section13'].video_preview.data) ? sections['section13'].video_preview.data.attributes.alternativeText : ''}
                        />
                        <img
                            src={apiServer + ((sections['section13'] && sections['section13'].video.data) ? sections['section13'].video.data.attributes.url : '')}    
                            alt={(sections['section13'] && sections['section13'].video.data) ? sections['section13'].video.data.attributes.alternativeText : ''}
                        />
                        <img
                            src={apiServer + ((sections['section13'] && sections['section13'].background1.data) ? sections['section13'].background1.data.attributes.url : '')}    
                            alt={(sections['section13'] && sections['section13'].background1.data) ? sections['section13'].background1.data.attributes.alternativeText : ''}
                        />
                        <img
                            src={apiServer + ((sections['section13'] && sections['section13'].background2.data) ? sections['section13'].background2.data.attributes.url : '')}    
                            alt={(sections['section13'] && sections['section13'].background2.data) ? sections['section13'].background2.data.attributes.alternativeText : ''}
                        />
                    </div>
                </div>
            </div>
            {/if}

            {#if sections['section14'].show_or_hide === 'show'}
            <div class="client-container" style="background-color: transparent;" id="section14">
                <div class="section-container">
                    <div class='right-images'>
                        <img
                            src={apiServer + ((sections['section14'] && sections['section14'].background2.data) ? sections['section14'].background2.data.attributes.url : '')}
                            style="max-width: 400px; max-height: 400px;"
                            alt={(sections['section14'] && sections['section14'].background2.data) ? sections['section14'].background2.data.attributes.alternativeText : ''}
                            class="address family"
                        />
                    </div>
                    <div class="text-container stay-text story-text">
                        <h1 class="circle-text">
                            {sections['section14'] ? sections['section14'].title : ''}
                        </h1>
                        <p class="client-description story-desc">
                            {sections['section14'] ? sections['section14'].content : ''}
                        </p>
                    </div>
                </div>
            </div>
            {/if}

            {#if sections['section15'].show_or_hide === 'show'}
            <div
                class="instant-section"
                style={`background-image: url(${apiServer + ((sections['section15'] && sections['section15'].background1.data) ? sections['section15'].background1.data.attributes.url : '')});`}
                id="section15"
            >
                <div class="instant" style="padding: 40px;">
                    <div class="instant-text-turbocharge">
                        {sections['section15'] ? sections['section15'].title : ''}
                    </div>
                    <p class="instant-desc">
                        {sections['section15'] ? sections['section15'].content : ''}
                    </p>
                    <div class="sale-button">
                        <Button on_click_func={on_click_func} title={sections['section15'] ? sections['section15'].button_text : ''} />
                    </div>
                </div>
            </div>
            {/if}
        {:else}
            <div class="loader-container">
                <div class="loader"/>
            </div>
        {/if}
    </Layout>
</div>
<style src="../styles/home.css">
</style>